import { render, staticRenderFns } from "./EditTagsModal.vue?vue&type=template&id=d6549bca&scoped=true&"
import script from "./EditTagsModal.vue?vue&type=script&lang=js&"
export * from "./EditTagsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditTagsModal.vue?vue&type=style&index=0&id=d6549bca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6549bca",
  null
  
)

export default component.exports